// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__8fuVK","fullPage":"Loading_fullPage__30epx"};